export const GET_SESSION_LOGS_REQUEST = "GET_SESSION_LOGS_REQUEST";
export const GET_SESSION_LOGS_SUCCESS = "GET_SESSION_LOGS_SUCCESS";
export const GET_SESSION_LOGS_FAILURE = "GET_SESSION_LOGS_FAILURE";
